import Vue from 'vue';
import Vuex from 'vuex';
import * as Api from './api/index';


Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    loadingToast: true,
    userInfo: {},
  },
  mutations: {
    CHANGE_LOADING_STATUS: (state, status) => {
      state.loadingToast = status;
    },
    SET_USER: (state, status) => {
      state.userInfo = status;
    },
  },
  actions: {
    // 改变loading 状态
    changLoadingStatus(context, { status }) {
      context.commit('CHANGE_LOADING_STATUS', status);
    },
    async setUser(context) {
      const { content } = await Api.studentList();
      context.commit('SET_USER', content);
      return content;
    },
  },
  getters: {
    getUserInfo(state) {
      return state.userInfo;
    },
  },
});
